import { getProps } from 'utils/global-utils';
import fetchApi from 'utils/api-utils';
import encodeRequestToHtml from 'utils/encoder';

const REACT_APP_REPORT_A_BUG_URL = process.env.REACT_APP_REPORT_A_BUG_URL;

export const reportBugToBackend = async ({
  message,
  partner,
  picture,
  recaptchaToken,
  recipients,
}) => {
  return await fetchApi(REACT_APP_REPORT_A_BUG_URL, {
    headers: {
      'content-type': 'application/json; charset=utf-8',
      'g-recaptcha': recaptchaToken,
    },
    body: encodeRequestToHtml({
      message,
      partner,
      picture,
      recipients,
    }),
    method: 'POST',
  }).then(async rs => {
    const data = getProps(rs, 'json') && (await rs.json());
    return { status: rs.status, ok: rs.ok, result: data?.id };
  });
};

const pictureDefaultActions = { reportBugToBackend };

export default pictureDefaultActions;
